export default "__VITE_ASSET__92A5OkEV__"